import * as React from 'react';

import { InputBaseProps as InputBasePropsM } from '@mui/material/InputBase';

import IconButton from '../IconButton/IconButton.jsx';
import Tooltip, { TooltipProps } from '../Tooltip/Tooltip.jsx';
import { StyledInputBase } from './FilterSearchInputBase.styles.jsx';

export interface FilterInputBaseProps extends InputBasePropsM {
  placeholder?: string;
  readOnly?: boolean;
  startAdornment?: React.ReactNode;
  type?: string;
  value?: unknown;
  onClear?: () => void;
  tooltipProps?: Partial<TooltipProps>;
}

const FilterSearchInputBase = ({
  value,
  onChange,
  onKeyDown,
  placeholder,
  onClear,
  disabled,
  tooltipProps,
  ...props
}: FilterInputBaseProps) => {
  const InputComponent = (
    <StyledInputBase
      size="small"
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      endAdornment={
        <IconButton
          size="small"
          variant="icon"
          icon="Close"
          sx={{
            visibility: value && !disabled ? 'visible' : 'hidden',
            '&.MuiIconButton-root.icon': {
              '&:focus': {
                boxShadow: 'none',
              },
            },
          }}
          onClick={onClear}
        />
      }
      {...props}
    />
  );

  return disabled ? (
    <Tooltip title="disabled" {...tooltipProps}>
      <div style={{ width: 'fit-content' }}>{InputComponent}</div>
    </Tooltip>
  ) : (
    InputComponent
  );
};

export default FilterSearchInputBase;
